// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info_note_content a{--tw-text-opacity:1;color:#1f50ab;text-decoration-line:underline}@supports (color:rgb(0 0 0/0)){.info_note_content a{color:rgb(31 80 171/var(--tw-text-opacity,1))}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
